import Config from '@/config';
import http from './http';

export default {
  upload: async (files) => {
    const data = new FormData();

    Array.from(files).forEach((file) => {
      data.append('filename[]', file);
    });

    const response = await http.post(
      `${Config.apiHost}/file/upload/tmpfile/`,
      data,
      {
        headers: {
          skipRenew: true,
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  },

  remove: async (id) => {
    const response = await http.post(
      `${Config.apiHost}/file/delete/tmpfile/`,
      { ids: [id] },
      {
        headers: {
          skipRenew: true,
        },
      },
    );
    return response.data;
  },
};
